// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-chevron[data-v-82a18986] {\n  font-size: 12px;\n}\n.label-input[data-v-82a18986] {\n  font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
